import React from 'react';
import { useIdentityPreferences, IdentityPreferencesProvider } from 'design-system/my-lib';

/**
 * Bridges the Redux-backed useIdentityPreferences hook to the
 * IdentityPreferencesContext so the design system components
 * (UserIdentity, etc.) can access preferences without Redux.
 */
export const IdentityPreferencesReduxProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const prefs = useIdentityPreferences();

  return (
    <IdentityPreferencesProvider value={prefs}>
      {children}
    </IdentityPreferencesProvider>
  );
};
